module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGklEQVRYhe3BAQEAAACCIP+vbkhAAQAAAO8GECAAAUcBoIgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/empty.png
// module id = 146
// module chunks = 0